module.exports = __webpack_public_path__ + "img/creditcard.bc74220b.svg";